import { Button } from '../../components/Button/NewButton';

interface Props {
  disabled?: boolean;
  badgeContent: string | number | undefined;
  onClick(): void;
}

export const CcButton = ({ badgeContent, disabled, onClick }: Props) => (
  <Button
    className="mr-2"
    minWidth={70}
    onClick={onClick}
    typeCasing="capitalize"
    disabled={disabled}
  >
    <span className="relative">
      Cc
      <span className="absolute -top-1 -right-4 w-4 h-4 flex items-center justify-center text-xs text-white bg-primary rounded-full">
        {badgeContent}
      </span>
    </span>
  </Button>
);
